'use client';

import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import { rscCompatibleApolloClient } from '@services/apollo';
import type { ReactNode } from 'react';

export function RscCompatibleApolloProvider({ children }: { children: ReactNode }) {
  return (
    <ApolloNextAppProvider makeClient={() => rscCompatibleApolloClient}>{children}</ApolloNextAppProvider>
  );
}
